import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints';

export async function getExtendedLeadsReport(query) {
        let response = await axios.get(`${LEADS_ENDPOINT}/generateExtendedExcel${query}`,
            {
                timeout: 1800000 // 30 minutos
            });
        return response.data
}
